import { render } from "./instructor-inprogress-tickets.vue?vue&type=template&id=0c66ef1f"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__